"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'bcm',
  // ドキュメント管理ウィンドウキー
  DOCUMENT_MNG_WINDOW_KEY: 'bcmSubWindow',
  // ドキュメント管理別ウィンドウサイズ：横幅
  DOCUMENT_MNG_WINDOW_SIZE_WIDTH: 1400,
  // ドキュメント管理別ウィンドウサイズ：縦幅
  DOCUMENT_MNG_WINDOW_SIZE_HEIGHT: 768
});